import './App.css';
import LZHXComponentHomePage from './componentHomePage/LZHXComponentHomePage';
import LZHXOrderDetailPage from './orderDetail/LZHXOrderDetailPage';
import LZPrivacyDetailPage from './privacy/LZPrivacyDetailPage';
import LZPrivacySDKListPage from './privacy/LZPrivacySDKListPage';
import LZLuckyDrawPage from './luckyDrawPage/LZLuckyDrawPage';
import LZPrivacyAuthPage from './privacy/LZPrivacyAuthPage';

function App() {
  let to = getQueryVariable("to");
  if (to != undefined && to != "") {
    if (to === "orderDetail") {
      var obj = document.getElementById("root");
      obj.style.backgroundColor= "#f5f5f5";
  
      return (
        <div className="App">
          <LZHXOrderDetailPage/>
        </div>
      );
    } else if (to === "privacyDetail") {
      return (
        <div className="App">
          <LZPrivacyDetailPage/>
        </div>
      );
    } else if (to === "privacySDKList") {
      return (
        <div className="App">
          <LZPrivacySDKListPage/>
        </div>
      );
    } else if (to === 'privacyAuthList') {
      return (
        <div className="App">
          <LZPrivacyAuthPage />
        </div>
      );
    } else if (to === "luckydraw") {
      var obj = document.getElementById("root");
      obj.style.padding= "0px";

      return (
        <div className="App">
          <LZLuckyDrawPage />
        </div>
      );
    }
  }

  return (
    <div className="App">
      <LZHXComponentHomePage />
    </div>
  );
}

function getQueryVariable(variable)
{
  var query = window.location.search.substring(1);
  console.log(query);

  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable) {return pair[1];}
  }
  return(false);
}

export default App;
